export const SET_TERM_OPEN_STORE = "SET_TERM_OPEN_STORE";
export const SET_TERM_OPEN_RESET = "SET_TERM_OPEN_RESET";
// Lay thong tin chung
export const FETCH_TERM_DEPOSIT_INFO_REQUEST = "FETCH_TERM_DEPOSIT_INFO_REQUEST";
export const FETCH_TERM_DEPOSIT_INFO_SUCCESS = "FETCH_TERM_DEPOSIT_INFO_SUCCESS";
export const FETCH_TERM_DEPOSIT_INFO_FAILURE = "FETCH_TERM_DEPOSIT_INFO_FAILURE";

// Lay danh sach ky han
export const FETCH_TERM_DEPOSIT_TERM_REQUEST = "FETCH_TERM_DEPOSIT_TERM_REQUEST";
export const FETCH_TERM_DEPOSIT_TERM_SUCCESS = "FETCH_TERM_DEPOSIT_TERM_SUCCESS";
export const FETCH_TERM_DEPOSIT_TERM_FAILURE = "FETCH_TERM_DEPOSIT_TERM_FAILURE";

// Lay hinh thuc dao han
export const FETCH_TERM_DEPOSIT_MATURITY_REQUEST = "FETCH_TERM_DEPOSIT_MATURITY_REQUEST";
export const FETCH_TERM_DEPOSIT_MATURITY_SUCCESS = "FETCH_TERM_DEPOSIT_MATURITY_SUCCESS";
export const FETCH_TERM_DEPOSIT_MATURITY_FAILURE = "FETCH_TERM_DEPOSIT_MATURITY_FAILURE";

// Lấy danh sách mã ưu đãi
export const FETCH_TERM_DEPOSIT_PROMO_CODE_REQUEST = "FETCH_TERM_DEPOSIT_PROMO_CODE_REQUEST";
export const FETCH_TERM_DEPOSIT_PROMO_CODE_SUCCESS = "FETCH_TERM_DEPOSIT_PROMO_CODE_SUCCESS";
export const FETCH_TERM_DEPOSIT_PROMO_CODE_FAILURE = "FETCH_TERM_DEPOSIT_PROMO_CODE_FAILURE";

// Kiểm tra Mở sổ
export const FETCH_TERM_DEPOSIT_OPEN_CREATE_REQUEST = "FETCH_TERM_DEPOSIT_OPEN_CREATE_REQUEST";
export const FETCH_TERM_DEPOSIT_OPEN_CREATE_SUCCESS = "FETCH_TERM_DEPOSIT_OPEN_CREATE_SUCCESS";
export const FETCH_TERM_DEPOSIT_OPEN_CREATE_FAILURE = "FETCH_TERM_DEPOSIT_OPEN_CREATE_FAILURE";

// Xác nhận mở sổ
export const FETCH_TERM_DEPOSIT_OPEN_CONFIRM_REQUEST = "FETCH_TERM_DEPOSIT_OPEN_CONFIRM_REQUEST";
export const FETCH_TERM_DEPOSIT_OPEN_CONFIRM_SUCCESS = "FETCH_TERM_DEPOSIT_OPEN_CONFIRM_SUCCESS";
export const FETCH_TERM_DEPOSIT_OPEN_CONFIRM_FAILURE = "FETCH_TERM_DEPOSIT_OPEN_CONFIRM_FAILURE";

// Xác thực mở sổ
export const FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_REQUEST = "FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_REQUEST";
export const FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_SUCCESS = "FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_FAILURE = "FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_FAILURE";

// Xác nhận tham dự CTKM
export const FETCH_TERM_DEPOSIT_PROMOTIONS_REQUEST = "FETCH_TERM_DEPOSIT_PROMOTIONS_REQUEST";
export const FETCH_TERM_DEPOSIT_PROMOTIONS_SUCCESS = "FETCH_TERM_DEPOSIT_PROMOTIONS_SUCCESS";
export const FETCH_TERM_DEPOSIT_PROMOTIONS_FAILURE = "FETCH_TERM_DEPOSIT_PROMOTIONS_FAILURE";
